import type { LanguageCode } from '@repo/domain';

// RSS feeds of the marketing website news, one per app language.
export const NEWS_FEED_URLS: Record<LanguageCode, string> = {
  en: 'https://parkapp.pl/en/news.xml',
  pl: 'https://parkapp.pl/news.xml',
};

// News published earlier than this many days ago is not shown.
export const NEWS_MAXIMUM_AGE_IN_DAYS = 7;
